import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-74" data-mp="9ka7f386p0z1">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      paddingTop: "0px"
    }} data-id="element-75" data-mp="9igxnf29y0mt">
        <h1 className="mx-auto mt-2 max-w-2xl font-display text-[23px] font-black uppercase leading-tight text-plum sm:text-[34px]" style={{
        paddingTop: "8px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-76" data-mp="129h0hmovcycw">
          Turn your book idea into a <span className="text-grape" data-id="element-77" data-mp="sa9rfbp63pvl">finished manuscript</span>
        </h1>

        <p className="pb-5 pt-3 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-plum/60 sm:text-sm" style={{
        paddingTop: "17px",
        paddingBottom: "10px"
      }} data-id="element-78" data-mp="ncq1hej3xont">
          The ultimate AI-powered author system to plan, write, develop, edit and finish your book without getting stuck.
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-79" data-mp="3j896f9neq5ny">
          <img src="https://cdn.magicpatterns.com/uploads/joTD4Avyf5TNFacTwT4XR6/Coleccion_de_ebooks_IA_futuristas.webp" alt="THE AI BOOK BUILDER™ — 100+ AI Prompts, 6-Volume Visual System + 4 Professional Bonuses" width={1536} height={1024} sizes="(min-width: 640px) 600px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[600px] object-contain" style={{
          marginTop: "-15px",
          marginBottom: "-15px",
          paddingTop: "21px",
          paddingBottom: "13px"
        }} data-id="element-80" data-mp="3e960zo3ilxfg" />
        </motion.div>

        <p className="mt-2 font-display text-sm font-black uppercase tracking-wide text-plum" data-id="element-81" data-mp="2hix2g62bkrr6">
          THE AI BOOK BUILDER™ <span className="font-semibold text-blush" data-id="element-82" data-mp="2ljgyt7f2jrc9">· The SIGMA SMART™ Method</span>
        </p>
        <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-83" data-mp="s2te9nr9cdqs">
          100+ AI Prompts — 6-Volume Visual System + 4 Professional Bonuses · ⭐ Built for modern authors · ⚡ Instant Access
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-84" data-mp="ia5k70rnwnvr">
          <CTAButton href="#pricing" data-id="element-85" data-mp="de6mgmkg1tio">See the AI Book Builder™ now</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-86" data-mp="1b1fgj5yigawa">
            <span className="font-bold text-plum" data-id="element-87" data-mp="1622hznya1fdv">📚 THE COMPLETE AI AUTHOR SYSTEM FOR 2026.</span>{' '}
            Designed for aspiring authors, self-published writers, first-time authors and writers who want a
            structured AI-assisted workflow to turn an idea into a finished manuscript.
          </p>

          <h2 className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-grape-deep sm:text-xl" data-id="element-88" data-mp="3ltgo5tkf8wpx">
            Book Planning · Characters · Worldbuilding · Chapters · Storytelling · Editing
          </h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-89" data-mp="1xa429a5swchi">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-gold/50 bg-white/80 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-90" data-mp="218toztcqb6dt">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-91" data-mp="2b1hgq9ouqk5o" />
                {label}
              </span>)}
          </div>

          <p className="mx-auto mt-6 max-w-2xl text-sm font-semibold italic text-grape-deep" data-id="element-92" data-mp="2fziz0segefg3">
            — Everything you need to build your book in one complete system —
          </p>
        </div>

        <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-gold/60 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-93" data-mp="2p1a9eajxvaga">
          🔥 Limited time offer · Launch price $27 USD · One-time payment
        </div>

        <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-medium text-plum/50" data-id="element-94" data-mp="zmc34an6n17a">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-95" data-mp="4a2tfh4nx3y1" />
          25 authors are viewing this offer right now
        </p>
      </div>
    </header>;
}